<template>
  <div>
    <p class="mb-0">
      <v-chip
        v-if="
          item_transactionable.match(/Ticket/g) && item_type == 'credit'
        "
        class="ma-2"
        color="red"
        small
        outlined
      >
        ใช้คะแนน
      </v-chip>
      <v-chip
        v-else-if="
          item_transactionable.match(/Ticket$/g) && item_type == 'debit'
        "
        class="ma-2"
        color="green"
        small
        outlined
      >
        รับคะแนน
      </v-chip>
    </p>
    <p
      v-if="item_remark"
      class="mb-0 d-inline-block"
      style="font-size: 0.8em; max-width: 230px; word-wrap: break-word"
      :title="item_remark"
    >
      {{ item_remark }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'PointType',
  props: {
    item_type: { required: true },
    item_transactionable: { required: true },
    item_remark: { required: true },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
